import styled from "styled-components";
import { adminShellMetrics } from "../../theme";

// Ported from gos-admin's topbar.style.js: a sticky bar that keeps its
// own stacking context and floats above the content on a soft shadow.
// Colours come from the Atlas custom properties rather than gos-admin's
// hardcoded whites, so the bar follows the light/dark switch.
const TopbarWrapper = styled.div`
  .admin-top-menu {
    position: sticky;
    top: 0;
    z-index: 20;
    width: 100%;
    height: ${adminShellMetrics.headerHeight}px;
    padding: 0;
    line-height: ${adminShellMetrics.headerHeight}px;
    background-color: var(--atlas-topbar-background);

    .admin-top-nav-header {
      position: relative;
      width: 100%;
      height: 100%;
      background-color: var(--atlas-topbar-background);
      box-shadow: ${adminShellMetrics.headerShadow};
      transition: background 0.3s;

      .admin-top-nav-header-main {
        display: flex;
        align-items: center;
        height: 100%;
        padding-inline: 16px;

        .admin-top-nav-header-main-left {
          display: flex;
          align-items: center;
          min-width: ${adminShellMetrics.siderWidth}px;

          .admin-top-nav-header-logo {
            position: relative;
            height: 100%;
            overflow: hidden;
            border: 0;
            padding: 0;
            background: transparent;
            cursor: pointer;

            img {
              display: inline-block;
              height: ${adminShellMetrics.logoSize}px;
              width: auto;
              vertical-align: middle;
            }

            h1 {
              display: inline-block;
              margin: 0 0 0 12px;
              color: var(--atlas-topbar-foreground);
              font-size: 18px;
              font-weight: 400;
              vertical-align: middle;
            }
          }
        }

        .admin-top-nav-header-menu {
          min-width: 0;
          flex: 1 1 0%;
        }

        .admin-top-nav-header-main-right {
          min-width: 32px;

          .admin-top-nav-header-main-right-container {
            display: flex;
            align-items: center;
            gap: 12px;
          }
        }
      }
    }
  }

  .account-menu-trigger {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    max-width: 240px;
    padding: 0;
    border: 0;
    background: transparent;
    cursor: pointer;

    .account-menu-label {
      max-width: 212px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      color: var(--atlas-topbar-foreground);
    }

    .account-menu-caret {
      color: var(--atlas-muted-foreground);
      font-size: 11px;
    }

    &:hover {
      .account-menu-label,
      .account-menu-caret {
        color: var(--atlas-brand);
      }
    }
  }

  /* The same two-state pill the landing page uses for el/en, sized to sit
     beside the antd buttons in the bar. */
  .admin-locale-switch {
    display: inline-flex;
    align-items: center;
    gap: 2px;
    padding: 2px;
    border: 1px solid var(--atlas-topbar-control-border);
    border-radius: 999px;
    background: var(--atlas-topbar-control-background);
    line-height: 1;

    button {
      padding: 5px 10px;
      border: 0;
      border-radius: 999px;
      background: transparent;
      color: var(--atlas-muted-foreground);
      font-family: inherit;
      font-size: 12px;
      font-weight: 700;
      cursor: pointer;

      &.on {
        background: var(--atlas-brand);
        color: var(--atlas-brand-foreground);
        cursor: default;
      }

      &:not(.on):hover {
        color: var(--atlas-topbar-foreground);
      }
    }
  }
`;

export default TopbarWrapper;
